<template>
  <MetricTotal
    :title="title"
    :item-id="itemId"
    :metric="metric"
    :owner-posts="true"
    v-bind="$attrs"
  />
</template>

<script>
import MetricTotal from '@/components/cards/MetricTotal';
import { POST_FIELDS } from '@/services/charts-service';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropInteractionsTotal',
  components: {
    MetricTotal,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    metric() {
      return POST_FIELDS.INTERACTIONS;
    },
  },
};
</script>
